
















































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import ModalMember from '@/components/manageGroup/members/ModalMember.vue';
import * as s_manageGroups_Interface from '../interface/store/manageGroups';
import { InventoryQueryParams } from '@/interface/store/inventory';
import { RequestQueryParams } from '@/interface/store/request';
import { Member } from '@/interface/store/manageGroups';

@Component({
  components: {
    ModalMember,
  },
})
export default class MobileHeader extends Vue {
  @Action('getQueryParams', { namespace: 'inventory' }) c_getInventoryQueryParams!: any;
  @Action('getQueryParams', { namespace: 'request' }) c_getRequestQueryParams!: any;
  @Action('logOut', { namespace: 'auth' }) c_logOut!: any;

  @Getter('getterGroupsMemberships', { namespace: 'manageGroup' })
  c_getterGroupsMemberships!: Array<s_manageGroups_Interface.GroupItem>;
  @Getter('getterLastGroupId') readonly c_getterLastGroupId!: string;
  @Getter('getterQueryParams', { namespace: 'inventory' })
  readonly c_getterInventoryQueryParams!: InventoryQueryParams;
  @Getter('getterQueryParams', { namespace: 'request' })
  readonly c_getterRequestQueryParams!: RequestQueryParams;
  @Getter('getterMe', { namespace: 'manageGroup' })
  readonly c_getterMe!: Member;

  @Mutation('RESET_ALL', { namespace: 'inventory' }) c_resetAllInventory!: any;
  @Mutation('RESET_ALL', { namespace: 'request' }) c_resetAllRequest!: any;
  @Mutation('RESET_ALL', { namespace: 'profile' }) c_resetAllProfile!: any;
  @Mutation('RESET_ALL', { namespace: 'manageGroup' }) c_resetAllManageGroups!: any;
  @Mutation('RESET_ALL') c_resetRootState!: any;
  @Mutation('IS_MOBILE_FILTER_PAGE_UP') c_IS_MOBILE_FILTER_PAGE_UP!: any;

  public isGroupsShown: boolean = false;
  public isMenuShown: boolean = false;
  public dialogVisible = false;
  public memberFilter = 'ACTIVE';

  mounted() {
    this.anyWhereClose('labSwap');
  }

  updated() {
    if (this.isMenuShown) {
      const sideMenuItems = document.getElementsByClassName('side-menu-item');

      for (let i = 0; i < sideMenuItems.length; i += 1) {
        sideMenuItems[i].addEventListener('click', this.closeSideMenu);
      }
    }

    if (this.isGroupsShown) {
      const currentItemElement = document.getElementsByClassName('current-item')[0];

      if (currentItemElement) {
        currentItemElement.scrollIntoView({ behavior: 'auto', block: 'center' });
      }
    }
  }

  closeSideMenu() {
    this.isMenuShown = false;
  }

  get currentGroupName() {
    let currentName: string = '';
    const groupId: string = this.$route.params.groupId;
    if (groupId === 'welcome' || this.c_getterGroupsMemberships.length < 1) currentName = 'Welcome';
    else {
      if (this.c_getterGroupsMemberships.length > 0) {
        currentName = this.c_getterGroupsMemberships.find((v: any) => v.fkGroup.id === groupId)!
          .fkGroup.name;
      }
    }
    return currentName;
  }

  createLab() {
    this.$root.$emit('createLab', true);
    this.isGroupsShown = false;
  }

  showHideList(type: string) {
    if (type === 'group') {
      this.isGroupsShown ? (this.isGroupsShown = false) : (this.isGroupsShown = true);
    } else if (type === 'menu') {
      this.isMenuShown ? (this.isMenuShown = false) : (this.isMenuShown = true);
    }
  }

  settingGroup() {
    let paramsId: string = this.$route.params.groupId;

    if (this.c_getterGroupsMemberships.length > 0) {
      if (this.$route.params.groupId === 'welcome') {
        alert('LAB을 선택해주세요');
        return false;
      } else {
        this.$router.push({
          name: 'ManageGroup',
          params: {
            groupId: paramsId,
          },
        });
      }
    } else {
      this.$message({
        showClose: true,
        type: 'warning',
        message: 'LAB 먼저 만들어주세요.',
      });
    }
  }

  async groupSwitching(item: any) {
    const routeObj: any = {
      path: `/groups/${item.fkGroup.id}/inventory`,
      query: {},
    };

    this.$root.$emit('rootEmitDeleteAllInventoryFilters');
    this.$root.$emit('rootEmitDeleteAllRequestFilters');
    this.c_IS_MOBILE_FILTER_PAGE_UP(false);

    if (this.$route.name !== 'ContentView') {
      await this.c_getRequestQueryParams({ groupId: item.fkGroup.id });
      const { hasDropdown, limit, offset, order, status } = this.c_getterRequestQueryParams;
      Object.assign(routeObj, {
        path: `/groups/${item.fkGroup.id}/requests`,
        query: {
          limit,
          page: offset + 1,
          sort: order,
        },
      });

      if (status) {
        routeObj.query = Object.assign({ status: status.split(',') }, routeObj.query);
      }

      if (hasDropdown) {
        Object.assign(routeObj.query, {
          hasDropdown,
        });
      }
    } else {
      await this.c_getInventoryQueryParams({ groupId: item.fkGroup.id });
      Object.assign(routeObj, {
        path: `/groups/${item.fkGroup.id}/inventory`,
        query: {
          limit: this.c_getterInventoryQueryParams.limit,
          page: this.c_getterInventoryQueryParams.offset + 1,
          sort: this.c_getterInventoryQueryParams.order,
        },
      });
    }
    await this.$router.push(routeObj);
  }

  anyWhereClose(refName: string) {
    document.addEventListener('click', (e: any) => {
      if ((this.$refs[refName] as HTMLElement) !== undefined) {
        if (
          !e.target.dataset.hasOwnProperty('currentSelect') &&
          !(this.$refs[refName] as HTMLElement).contains(e.target)
        ) {
          this.isGroupsShown = false;
        }
      }
    });
  }

  async goLogOut() {
    await this.c_logOut();
    await this.c_resetAllInventory();
    await this.c_resetAllManageGroups();
    await this.c_resetAllProfile();
    await this.c_resetAllRequest();
    await this.c_resetRootState();
  }

  onModalClose(bool: boolean): void {
    this.dialogVisible = bool;
  }

  onInviteSubmit(bool: boolean): void {
    this.dialogVisible = bool;
  }

  memberInviteOpen(): void {
    this.isMenuShown = false;
    if (this.c_getterGroupsMemberships.length < 1) {
      this.$message({
        showClose: true,
        type: 'warning',
        message: 'LAB 먼저 만들어주세요.',
      });
    } else this.dialogVisible = true;
  }
}
